module.exports = __webpack_public_path__ + "media/limitations/vigadesplazada-1aaa427b.png";